import { Tooltip, TooltipContent, TooltipTrigger } from "@exopengithub/exokit";
import type { ReactElement } from "react";
import { useLocale } from "src/locales/useLocale.ts";
import {
	type SyncStatusPresentation,
	syncStatusTooltipVariant,
} from "./syncStatusPresentation.ts";

type Props = {
	status: SyncStatusPresentation;
	children: ReactElement;
};

export const SyncStatusTooltip = ({ status, children }: Props) => {
	const { format } = useLocale();
	const wallClock = status.timestamp
		? format(status.timestamp, { dateStyle: "short", timeStyle: "medium" })
		: null;

	return (
		<Tooltip delay={500}>
			{/* WHY asChild: rows are often Links — TooltipTrigger's default button would fight their pointer cursor. */}
			<TooltipTrigger asChild>{children}</TooltipTrigger>
			<TooltipContent variant={syncStatusTooltipVariant[status.tone]}>
				{status.phrase}
				{wallClock && ` (${wallClock})`}
			</TooltipContent>
		</Tooltip>
	);
};
